import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import {
    buildErpPageHeading,
    stripErpModulePrefixFromHeading,
} from '../erp-module-page-title.util';

export interface HeaderConfig {
    title: string;
    buttons: {
        label: string;
        action?: () => void; // Make action optional
        type: 'primary' | 'secondary' |'dark' | 'dropdown'; // Add dropdown type
        disabled?: boolean;
        dropdownItems?: { label: string; action: () => void , icon?: string;}[]; // Support dropdown items
    }[];
}

@Injectable({
    providedIn: 'root'
})
export class HeaderService {
    private configSubject = new BehaviorSubject<HeaderConfig>({
        title: '',
        buttons: []
    });

    config$ = this.configSubject.asObservable();

    constructor(private readonly browserTitle: Title) {}

    setConfig(config: HeaderConfig) {
        const section = stripErpModulePrefixFromHeading(config.title);
        this.configSubject.next({ ...config, title: section });
        this.browserTitle.setTitle(buildErpPageHeading(section));
    }

    getConfig() {
        return this.configSubject.getValue();
    }

    /** Réapplique l’onglet après changement d’entreprise (sans écraser le libellé de page). */
    refreshBrowserTabFromCurrentConfig(): void {
        const current = this.configSubject.getValue();
        const section = String(current.title ?? '').trim();
        this.browserTitle.setTitle(buildErpPageHeading(section));
    }

  updateButtonState(label: string, disabled: boolean) {
    const currentConfig = this.configSubject.getValue();
    const updatedButtons = currentConfig.buttons?.map(button =>
      button.label === label ? { ...button, disabled } : button
    ) || [];
    this.configSubject.next({ ...currentConfig, buttons: updatedButtons });
  }
}
